import {
  Component,
  OnInit,
  AfterViewInit,
  Inject,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  NavigationEnd,
  NavigationStart,
  Router,
  RouterEvent,
} from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { DataService } from "../core/services/data.service";
import { filter } from "rxjs/operators";
import { HttpService } from "src/app/core/services/http.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  name = localStorage.getItem("name");
  position = localStorage.getItem("position");
  companyId = localStorage.getItem("companyId");
  checkCompany = localStorage.getItem("checkCompany") == "all";

  logo =
    `https://smart-factory-s.s3.ap-northeast-2.amazonaws.com/company/${this.companyId}/logo/logo.png` ||
    "assets/img/logo.png";
  // logo = !localStorage.getItem('logo') || localStorage.getItem('logo') === 'null' ? 'assets/img/logo.png' : localStorage.getItem('logo');

  configData;
  openSwitch = false;
  mbMenuShow = false;
  wdSize = window.innerWidth > 965;
  // mbShow = this.checkCompany && this.wdSize ? true : false;
  mbShow = this.companyId && this.wdSize ? true : false;

  //TODO 사이드 메뉴 리스트 넣기
  menu = [
    {
      label: "대시보드",
      icon: "bx-home",
      link: "/dashboard",
    },
    {
      label: "거래처",
      icon: "",
      link: "/client",
    },
    {
      label: "품목",
      icon: "",
      link: "/product",
    },
    {
      label: "회원 관리",
      icon: "bx-user",
      link: "/user-list",
    },
    {
      label: "컨텐츠 관리",
      icon: "bx-list-ul",
      subItems: [
        {
          label: "카테고리 관리",
          link: "/category-list",
        },
        {
          label: "게시물 관리",
          link: "/post-list",
        },
        {
          label: "광고 관리",
          link: "/ad-edit",
        },
        {
          label: "배너 관리",
          link: "/banner-edit",
        },
      ],
    },
    {
      label: "신고 관리",
      icon: "bx-error",
      subItems: [
        {
          label: "회원 신고 관리",
          link: "/report-user",
        },
        {
          label: "게시물 신고 관리",
          link: "/report-post",
        },
        {
          label: "댓글 신고 관리",
          link: "/report-comment",
        },
      ],
    },
    {
      label: "결제 관리",
      icon: "bx-credit-card",
      subItems: [
        {
          label: "결제 관리",
          link: "/payment-list",
        },
        {
          label: "환급 관리",
          link: "/exchange-list",
        },
      ],
    },
    {
      label: "서비스/정보관리",
      icon: "bx-note",
      subItems: [
        {
          label: "공지사항",
          link: "/notice",
        },
        {
          label: "1:1 문의",
          link: "/inquiry",
        },
        {
          label: "자주 묻는 질문",
          link: "/faq",
        },
        {
          label: "개인정보/서비스 이용약관",
          link: "/terms",
        },
      ],
    },
    // {
    //   label: '캘린더 관리',
    //   icon: 'bx-calendar',

    //   subItems: [
    //     {
    //       label: 'Calendar List',
    //       link: '/calendar-list',
    //     },
    //     {
    //       label: 'Calendar Card',
    //       link: '/calendar-card',
    //     },
    //   ],
    // },
    // {
    //   label: '기타 정보 관리',
    //   icon: 'bx-receipt',

    //   subItems: [
    //     {
    //       label: '약관 관리',
    //       link: '/terms',
    //     },
    //   ],
    // },
    // {
    //   label: '기타 서비스',
    //   icon: 'bx-note',
    //   subItems: [
    //     {
    //       label: 'iamport',
    //       link: '/iamport',
    //     },
    //     {
    //       label: 'barobill',
    //       link: '/barobill',
    //     },
    //     {
    //       label: 'web-image',
    //       link: '/web-image',
    //     },
    //     {
    //       label: 'pdf',
    //       link: '/pdf',
    //     },
    //     {
    //       label: 'excel',
    //       link: '/excel',
    //     },
    //   ],
    // },
  ];

  routerUrl: string;

  readonly nicknameRoleMap: Record<string, string> = {
    관리자: "권한 - 관리자",
    "디지털 1호기": "권한 - 인쇄",
    "디지털 2호기": "권한 - 인쇄",
    후렉소: "권한 - 인쇄",
    옵셋: "권한 - 인쇄",
    "3호기 + 투타발": "권한 - 타발",
    "고속1 + 2호기": "권한 - 타발",
    "고속2 + 동관": "권한 - 타발",
    "슬렛트 + 포장": "권한 - 슬렛트",
  };

  public nickname = localStorage.getItem("name");
  public roleText: string | null = null;

  constructor(
    public data: DataService,
    private http: HttpService,
    private router: Router,
    private modalService: NgbModal,
    @Inject(DOCUMENT) private document: any
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        // this._activateMenuDropdown();
        this.routerUrl = event.url;
      }
    });

    this.router.events
      .pipe(filter((ev) => ev instanceof NavigationStart))
      .subscribe((ev: RouterEvent) => {
        const currentURL = ev.url.split("?")[0];
        if (currentURL !== "/account/login") {
          this.data.getWaitOrderCount();
        }
        // 페이지 이동 시 모든 모달 닫기
        this.modalService.dismissAll();
      });

    if (this.position === "null") {
      this.position = "";
    }
  }

  ngOnInit() {
    //사이드바 정의
    document.body.setAttribute("data-sidebar", "dark");
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.roleText = this.nicknameRoleMap[this.nickname] ?? null;
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle("right-bar-enabled");
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle("sidebar-enable");
    document.body.classList.toggle("vertical-collpsed");

    if (window.screen.width <= 768) {
      document.body.classList.remove("vertical-collpsed");
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle("mm-show");
  }

  scrollable() {
    document.body.setAttribute("data-layout-scrollable", "true");
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  public hide() {
    document.body.classList.remove("right-bar-enabled");
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>(".active");
    if (activeTag) {
      activeTag.classList.remove("active");
    }
    if (list.openSwitch) {
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach((ele) => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(
              `.atag${mi}${index}`
            );
            aTag.classList.add("active");
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add("active");
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }

  // _activateMenuDropdown() {
  //   this._removeAllClass('mm-active');
  //   this._removeAllClass('mm-show');
  //   const links = document.getElementsByClassName('side-nav-link-ref');
  //   let menuItemEl = null;
  //   // tslint:disable-next-line: prefer-for-of
  //   const paths = [];
  //   for (let i = 0; i < links.length; i++) {
  //     paths.push(links[i]['pathname']);
  //   }
  //   var itemIndex = paths.indexOf(window.location.pathname);
  //   if (itemIndex === -1) {
  //     const strIndex = window.location.pathname.lastIndexOf('/');
  //     const item = window.location.pathname.substr(0, strIndex).toString();
  //     menuItemEl = links[paths.indexOf(item)];
  //   } else {
  //     menuItemEl = links[itemIndex];
  //   }
  //   if (menuItemEl) {
  //     menuItemEl.classList.add('active');
  //     const parentEl = menuItemEl.parentElement;
  //     if (parentEl) {
  //       parentEl.classList.add('mm-active');
  //       const parent2El = parentEl.parentElement.closest('ul');
  //       if (parent2El && parent2El.id !== 'side-menu') {
  //         parent2El.classList.add('mm-show');
  //         const parent3El = parent2El.parentElement;
  //         if (parent3El && parent3El.id !== 'side-menu') {
  //           parent3El.classList.add('mm-active');
  //           const childAnchor = parent3El.querySelector('.has-arrow');
  //           const childDropdown = parent3El.querySelector('.has-dropdown');
  //           if (childAnchor) {
  //             childAnchor.classList.add('mm-active');
  //           }
  //           if (childDropdown) {
  //             childDropdown.classList.add('mm-active');
  //           }
  //           const parent4El = parent3El.parentElement;
  //           if (parent4El && parent4El.id !== 'side-menu') {
  //             parent4El.classList.add('mm-show');
  //             const parent5El = parent4El.parentElement;
  //             if (parent5El && parent5El.id !== 'side-menu') {
  //               parent5El.classList.add('mm-active');
  //               const childanchor = parent5El.querySelector('.is-parent');
  //               if (childanchor && parent5El.id !== 'side-menu') {
  //                 childanchor.classList.add('mm-active');
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  // // 메뉴 클릭시 다른주소 remove class
  // _removeAllClass(className) {
  //   const els = document.getElementsByClassName(className);
  //   while (els[0]) {
  //     els[0].classList.remove(className);
  //   }
  // }

  //이동
  goDashboard() {
    if (this.checkCompany) {
      this.router.navigateByUrl("/dashboard");
    } else {
      this.router.navigateByUrl("/i-dashboard");
    }
  }

  // 주문/승인
  goOrder() {
    if (this.checkCompany) {
      this.router.navigateByUrl("/order");
    } else {
      this.router.navigateByUrl("/i-order");
    }
  }

  // 생산/출하 승인
  goManufacture() {
    this.router.navigateByUrl("/manufacture");
  }

  // 분석
  goAnalysis() {
    this.router.navigateByUrl("/analysis");
  }

  // 영업이익률
  goCompanyProfit() {
    this.router.navigateByUrl("/company-profit");
  }

  // 수주출하리드타임
  goLeadTime() {
    this.router.navigateByUrl("/lead-time");
  }

  //납기단축
  goDeadlineInfo() {
    this.router.navigateByUrl("/deadline-info");
  }

  //자재/생산품
  goProduct() {
    if (this.checkCompany) {
      this.router.navigateByUrl("/product");
    } else {
      this.router.navigateByUrl("/i-product");
    }
  }

  //거래처
  goClient() {
    this.router.navigate(["/client"]);
  }

  //설정
  goSetting() {
    this.router.navigate(["/setting"]);
  }

  //bom
  goBom() {
    this.router.navigate(["/bom-manage"]);
  }

  //공정
  goProcess() {
    this.router.navigate(["/process"]);
  }

  redirectToUrl(link: String) {
    this.router.navigate([link]);
  }

  // 로그아웃
  async logout() {
    const obj = {
      user_id: localStorage.getItem("email"),
      requested_url: location.href,
      header_info: "logout",
      body_info: "logout",
    };

    await this.http.post(`/log_history`, obj, { Headers });

    localStorage.removeItem("token");
    localStorage.removeItem("companyId");
    localStorage.removeItem("autoLogin");
    localStorage.removeItem("name");
    localStorage.removeItem("position");
    localStorage.removeItem("checkCompany");

    this.router.navigate(["/account/login"]);
  }

  showFooter() {
    return !this.checkCompany && this.wdSize ? true : false;
  }

  mbMenu() {
    this.mbMenuShow = !this.mbMenuShow;
  }

  //사용 내역
  goLogHistory() {
    this.router.navigateByUrl("/log-history");
  }
}
